import { render, staticRenderFns } from "./SelectedProduct.vue?vue&type=template&id=46d44b70&scoped=true&"
import script from "./SelectedProduct.vue?vue&type=script&lang=js&"
export * from "./SelectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProduct.vue?vue&type=style&index=0&id=46d44b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d44b70",
  null
  
)

export default component.exports